import { CommonModule } from '@angular/common';
// Angular Imports
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgcCommonModule } from '../../common/common.module';
import { ConfigModule } from '../../config/config.module';
import { NgcPipesModule } from '../../pipes/module';
import { FlyoutLangselectorComponent } from './flyout-langselector.component';

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgcCommonModule,
    BsDropdownModule.forRoot(),
    ConfigModule,
    CommonModule,
    NgcPipesModule
  ],
  declarations: [FlyoutLangselectorComponent],
  exports: [FlyoutLangselectorComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FlyoutLangselectorModule {}
